import { render } from "./OidcCallbackError.vue?vue&type=template&id=42aa390e"
import script from "./OidcCallbackError.vue?vue&type=script&lang=js"
export * from "./OidcCallbackError.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Unifi.Web\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__